export default __webpack_public_path__ + "static/media/img16.865740c3.png";